import newProjectItem from "../../../spendMode/prefab/dialog/newProjectItem";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 *
 */
@ccclass
export default class RankNode extends cc.Component {

    @property({type:cc.Label,displayName:""})
    lbTitle : cc.Label = null;
    @property({type:cc.Label,displayName:""})
    lbBtnStr : cc.Label = null;
    @property({type:cc.Label,displayName:""})
    lbTitleAsset : cc.Label = null;

    @property({type:cc.PageView , displayName:"pageView组件"})
    pageView : cc.PageView = null;
    @property({type:cc.Node,displayName:"内容中心节点"})
    centerNode : cc.Node = null;
    @property({type:cc.Node,displayName:"浮动按钮"})
    btnFloatBtnNode : cc.Node = null;

    onLoad () {}

    start () {
        this.pageView.setCurrentPageIndex(0);
        this.pageView.node.on('page-turning', this.pageChange, this);
    }

    /**
     *
     */
    pageChange( pageView ){
        // this.btnRefresh( pageView.getCurrentPageIndex() );
    }

    /**
     *
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }

    /**
     * 选择上栏
     */
    onBtnChooseBarBtn( e , define ){
        this.pageView.setCurrentPageIndex( Number(define) );
        this.btnRefresh( Number(define ) );
    }

    //刷新按钮
    btnRefresh( define : number ){
        let x : number = 0;
        switch ( define ) {
            case 0:
                this.lbTitle.string = `新人财富榜`;
                this.lbBtnStr.string = `新人榜`;
                this.lbTitleAsset.string = `资产`;
                x = -150;
                break;
            case 1:
                this.lbTitle.string = `世界财富榜`;
                this.lbBtnStr.string = `世界榜`;
                this.lbTitleAsset.string = `资产`;
                x = 10;
                break;
            case 2:
                // this.lbTitle.string = `捐献贡献榜`;
                // this.lbBtnStr.string = `捐献榜`;
                // this.lbTitleAsset.string = `贡献值`;
                // x = 170;
                break;
        }
        cc.tween( this.btnFloatBtnNode )
            .to( 0.3 , { x : x })
            .start();
    }

}
